"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideModal = void 0;

var _react = require("react");

var _styles = require("./styles");

var _iconsMaterial = require("@mui/icons-material");

var _jsxRuntime = require("react/jsx-runtime");

var SideModal = function SideModal(_ref) {
  var header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      show = _ref.show,
      setShow = _ref.setShow,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "side-modal" : _ref$id;
  var modal = (0, _react.useRef)();

  var closeModal = function closeModal(e) {
    if (!e.target.closest("#".concat(id)) && show) {
      var _modal$current, _modal$current$classL;

      document.removeEventListener("click", closeModal, false);
      modal === null || modal === void 0 ? void 0 : (_modal$current = modal.current) === null || _modal$current === void 0 ? void 0 : (_modal$current$classL = _modal$current.classList) === null || _modal$current$classL === void 0 ? void 0 : _modal$current$classL.remove("shown");
      setShow && setShow(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (show && modal.current) {
      var _modal$current2, _modal$current2$class;

      document.addEventListener("click", closeModal, false);
      modal === null || modal === void 0 ? void 0 : (_modal$current2 = modal.current) === null || _modal$current2 === void 0 ? void 0 : (_modal$current2$class = _modal$current2.classList) === null || _modal$current2$class === void 0 ? void 0 : _modal$current2$class.add("shown");
    }
  }, [show]);
  (0, _react.useEffect)(function () {
    return function () {
      var _modal$current3, _modal$current3$class;

      document.removeEventListener("click", closeModal, false);
      modal === null || modal === void 0 ? void 0 : (_modal$current3 = modal.current) === null || _modal$current3 === void 0 ? void 0 : (_modal$current3$class = _modal$current3.classList) === null || _modal$current3$class === void 0 ? void 0 : _modal$current3$class.remove("shown");
      setShow && setShow(false);
    };
  }, []);
  return show && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: id,
      ref: modal,
      className: "modal-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal-header",
        children: header
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal-body",
        children: body
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "modal-footer",
        children: footer
      })]
    })
  });
};

exports.SideModal = SideModal;